export default class Storage {
    static _prefix = "_snake_";

    static set = (key, value, callback = null) => {
        value = this.#encrypt(value);

        localStorage.setItem(this._prefix + key, value);
        localStorage.getItem(this._prefix + key);

        if (callback) callback();
    };

    static get = (key, callback = null) => {
        let value = localStorage.getItem(this._prefix + key);

        value = this.#decrypt(value);

        const result = value === "null" || value === null ? null : value;

        if (callback) callback(result);
        else return result;
    };

    static delete = (key, callback = null) => {
        localStorage.removeItem(this._prefix + key);

        if (callback) callback();
    };

    static clear = (callback = null) => {
        for (const key in { ...localStorage }) {
            // if (![this._prefix + "sku", this._prefix + "code", this._prefix + "init", this._prefix + "payment_method"].includes(key)) localStorage.removeItem(key);

            localStorage.removeItem(key);
        }

        if (callback) callback();
    };

    static #encrypt = (value) => {
        // const spy = Math.floor(Math.random() * 9) + 1;
        // return spy + Array.from(Array(spy), () => Math.floor(Math.random() * 36).toString(36)).join("") + btoa(encodeURIComponent(value));

        return value;
    };

    static #decrypt = (value) => {
        // return value ? decodeURIComponent(atob(value.slice(parseInt(value.charAt(0)) + 1))) : null;

        return value || null;
    };
}
